import React from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';

interface Props {}

const G: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.G');

    return (
        <section
            id="rapid-mag-G"
            className={`rapid-mag-G ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-G'}
            data-section-title={t('title')}
        >
            <div className="img">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/figma-uploads/1762505326551-igfoko-compressed-Frame%201612707565.jpg"
                    pad="https://websiteoss.ecoflow.com/figma-uploads/1762505326551-igfoko-compressed-Frame%201612707565.jpg"
                    h5="https://websiteoss.ecoflow.com/figma-uploads/1762505337746-nam6fq-compressed-Frame%201000008961.jpg"
                />
            </div>
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="subtitle">{t('subtitle')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
        </section>
    );
};
export default G;
